const getElementDataAttributes = (element, attributeNamePrefix = "contember") => {
  const { children, ...extendedSpecifics } = element;
  return Object.fromEntries(
    Object.entries(extendedSpecifics).filter(([, value]) => {
      const t = typeof value;
      return t === "string" || t === "number" || t === "boolean";
    }).map(([attribute, value]) => [`data-${attributeNamePrefix}-${attribute.toLowerCase()}`, value])
  );
};
export {
  getElementDataAttributes
};
//# sourceMappingURL=getElementDataAttributes.js.map
